var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBscLogo3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 440,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    width: 1.5,
    height: 1.5,
    x: -0.25,
    y: -0.25
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "SourceGraphic",
    result: "result0"
  }), /*#__PURE__*/React.createElement("feDiffuseLighting", {
    lightingColor: "#fff",
    surfaceScale: 4,
    result: "result5"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    elevation: 45,
    azimuth: 235
  })), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 1.4,
    in: "result5",
    result: "fbSourceGraphic",
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "result0",
    in: "fbSourceGraphic",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feSpecularLighting", {
    specularExponent: 25,
    surfaceScale: 4,
    lightingColor: "#fff",
    result: "result1",
    in: "result0"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    azimuth: 235,
    elevation: 45
  })), /*#__PURE__*/React.createElement("feComposite", {
    in2: "result1",
    k3: 1,
    k2: 1,
    operator: "arithmetic",
    result: "result4",
    in: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic",
    in: "result4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "fbSourceGraphicAlpha",
    stdDeviation: 40,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "bluralpha",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "bluralpha",
    dy: 40,
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "fbSourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 100 100)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.772 0 0 44.772 0 100v800c0 55.229 44.772 100 100 100h200c165.685 0 300-134.315 300-300 0-76.84-28.898-146.923-76.406-200C571.102 446.923 600 376.84 600 300 600 134.315 465.685 0 300 0H100zm200 200c55.228 0 100 44.772 100 100s-44.772 100-100 100-100-44.772-100-100 44.772-100 100-100zm0 400c55.228 0 100 44.772 100 100s-44.772 100-100 100-100-44.772-100-100 44.772-100 100-100z",
    fill: "#00f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 0C134.315 0 0 134.315 0 300s134.315 300 300 300c55.228 0 100 44.772 100 100s-44.772 100-100 100c-54.366 0-98.6-43.37-99.969-97.406-.021-.858-.031-1.731-.031-2.594 0-55.228-44.772-100-100-100S0 644.772 0 700c0 .866.024 1.73.031 2.594C1.426 867.084 135.181 1000 300 1000c165.685 0 300-134.315 300-300S465.685 400 300 400c-9.492 0-18.675-1.31-27.375-3.781-.79-.225-1.592-.476-2.375-.719C229.543 382.839 200 344.873 200 300c0-.863.01-1.736.031-2.594 1.13-44.6 31.465-81.944 72.594-93.625.79-.224 1.576-.42 2.375-.625A100.252 100.252 0 01300 200c55.228 0 100 44.772 100 100s44.772 100 100 100 100-44.772 100-100c0-.866-.024-1.73-.031-2.594C598.574 132.916 464.819 0 300 0z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 0c-.863 0-1.736.01-2.594.031C132.916 1.426 0 135.181 0 300s132.916 298.574 297.406 299.969c.858.021 1.731.031 2.594.031 55.228 0 100-44.772 100-100s-44.772-100-100-100-100-44.772-100-100 44.772-100 100-100 100-44.772 100-100S355.228 0 300 0z",
    fill: "#0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.772 0 0 44.772 0 100v800c0 55.229 44.772 100 100 100h200c165.685 0 300-134.315 300-300 0-76.84-28.898-146.923-76.406-200C571.102 446.923 600 376.84 600 300 600 134.315 465.685 0 300 0H100zm200 200c55.228 0 100 44.772 100 100s-44.772 100-100 100-100-44.772-100-100 44.772-100 100-100zm0 400c55.228 0 100 44.772 100 100s-44.772 100-100 100-100-44.772-100-100 44.772-100 100-100z",
    fill: "none",
    stroke: "#000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscLogo3D);
export default __webpack_public_path__ + "static/media/bsc_logo_3d.fc72b08ced50e67282f43b3affb475cb.svg";
export { ForwardRef as ReactComponent };